/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServiceCspUnGated { 
    /**
     * Whether VCDR service is un-gated in CSP
     */
    vcdr?: boolean;
    /**
     * Whether VMCFS service is un-gated in CSP
     */
    vmcfs?: boolean;
    /**
     * Whether VMUA service is un-gated in CSP
     */
    vmua?: boolean;
}

